/* loaded by smart-asset */
export default require("./32a~KvbjIBbt.svg")